import { useState } from 'react';
import { Icon } from './Icon';

/** Small inline copy-to-clipboard button (used for LB IPs etc.). */
export function CopyButton({ value }: { value: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      className="copy-btn"
      title={copied ? 'Copied' : `Copy ${value}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        navigator.clipboard?.writeText(value).then(
          () => {
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1200);
          },
          () => undefined,
        );
      }}
    >
      {copied ? <Icon name="check" /> : <Icon name="copy" />}
    </button>
  );
}
